import type { MiddlewareAPI } from 'redux';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import type { ActionsObservable } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import log from '@atlassian/jira-common-util-logging/src/log.tsx';
import type FetchError from '@atlassian/jira-fetch/src/utils/errors.tsx';
import copyBoard from '../../rest/copy-board/index.tsx';
import { type Action, COPY_BOARD, copyBoardFailed, boardCopied } from '../../state/actions.tsx';
import { getBoard, getOnBoardCopied, getOnBoardCopyFailed } from '../../state/selectors.tsx';
import type { State } from '../../state/types.tsx';

const copyBoardEpic = (action$: ActionsObservable<Action>, store: MiddlewareAPI<State>) =>
	action$.ofType(COPY_BOARD).mergeMap(() => {
		const state = store.getState();
		const board = getBoard(state);

		return Observable.fromPromise(copyBoard(board.id))
			.mergeMap((copiedBoardSummary) => {
				getOnBoardCopied(state)(board, copiedBoardSummary);
				return Observable.of(boardCopied());
			})
			.catch((error: FetchError) => {
				log.safeErrorWithoutCustomerData(
					'directories.boards-v2.copy-modal.ops.copy-board',
					error.message,
					error,
				);
				const reason = error.statusCode === 404 ? 'board-not-found' : 'unknown';
				getOnBoardCopyFailed(state)(board, reason);
				return Observable.of(copyBoardFailed({ reason }));
			});
	});

export default copyBoardEpic;
